/**
 * The stable prefixes on a `launcher_dispatch_log.error` that mean "this
 * member was deliberately SKIPPED", not "the send failed".
 *
 * Canonical here, in `src/shared/` (pure constants, safe in any bundle),
 * because both sides of the boundary need them: the mini-apps write and read
 * them (`mini-apps/_shared/launcher-copy-tokens.ts` re-exports both, with the
 * contract doc), and core's Clay dispatch-result callback
 * (`src/services/launcher/dispatch-result-callback.ts`) must NOT repair a
 * skipped row to `sent` — nothing was ever sent for it. One string each, one
 * place (plan 2026-09-26-003, U6).
 */

/** A member skipped because their copy carried an unknown token. */
export const COPY_DEFECT_ERROR_PREFIX = 'copy_defect:';

/** A member skipped because no sender could be resolved for them. */
export const SENDER_MISSING_ERROR_PREFIX = 'sender_missing:';

/** Every skip prefix — a row whose `error` starts with one of these was never sent. */
export const LAUNCHER_DISPATCH_SKIP_ERROR_PREFIXES: readonly string[] = [
  COPY_DEFECT_ERROR_PREFIX,
  SENDER_MISSING_ERROR_PREFIX,
];
